/**
 * Group a flat list of tool results into runs of consecutive calls that share
 * the same tool_name. Lets the timeline collapse e.g. four back-to-back
 * "Web Research" calls into a single summarized row while preserving the
 * original order and any interleaving with other tools.
 *
 * Example: [web, web, crm, web] -> [[web, web], [crm], [web]]
 */
export function groupConsecutiveByToolName<T extends { tool_name: string }>(
  results: readonly T[]
): T[][] {
  const groups: T[][] = [];
  for (const result of results) {
    const current = groups[groups.length - 1];
    if (current && current[0].tool_name === result.tool_name) {
      current.push(result);
    } else {
      groups.push([result]);
    }
  }
  return groups;
}
